import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { gradientDarkBackground } from "themes";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonIcon from "@mui/icons-material/Person";
import PaymentIcon from "@mui/icons-material/Payment";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import { useEffect, useState } from "react";

import GradientPageWrapper from "components/shared/GradientPageWrapper";
import Tabs from "components/shared/Tabs/Tabs";
import ProfileTab from "components/shared/Tabs/ProfileTab";
import VoiceConversionTab from "components/shared/Tabs/VoiceConversionTab";
import PaymentSettingsTab from "components/shared/Tabs/PaymentSettingsTab";
import { useUser } from "./../../hooks/users";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export default function Settings() {
  const [panel, setPanel] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event: React.SyntheticEvent, newPanel: number) => {
    navigate(`/settings${settingsTabs[newPanel].route}`);
    setPanel(newPanel);
  };

  useEffect(() => {
    const currentTab = settingsTabs.findIndex(
      (tab) => tab.route === `/${location.pathname.split("/")[2]}`
    );
    setPanel(currentTab);
  }, [location]);

  return (
    <GradientPageWrapper Icon={SettingsIcon} title="Account Settings">
      <Container>
        <StyledTabs
          tabs={settingsTabs}
          panel={panel}
          orientation="vertical"
          handleChange={handleChange}
        />
        <Outlet />
      </Container>
    </GradientPageWrapper>
  );
}

const settingsTabs = [
  { label: "Profile", route: "/profile", icon: PersonIcon },
  {
    label: "Voice Conversion",
    route: "/voice-conversion",
    icon: RecordVoiceOverIcon,
  },
  { label: "Payment Settings", route: "/payment-settings", icon: PaymentIcon },
];

const Container = styled(Box)({
  display: "flex",
  width: "100%",
  padding: "0 2rem",
  justifyContent: "space-around",
  position: "relative",
  top: "-6rem",
  gap: "1rem",
});

const StyledTabs = styled(Tabs)({
  width: "20rem",
  height: "23rem",
  borderRadius: "1rem",
  background: gradientDarkBackground,
});
